module.exports = __webpack_public_path__ + "19e42cb1df44ea807db41d9b576f1532.png";